import React from 'react';
interface TestimonialProps {
  name: string;
  role: string;
  text: string;
}
const TestimonialCard = ({
  name,
  role,
  text
}: TestimonialProps) => <div className="bg-brand-card p-5 rounded border border-black/10 flex flex-col h-full" data-id="element-196">
    <p className="text-brand-text text-sm md:text-base italic flex-grow leading-relaxed mb-4" data-id="element-197">
      "{text}"
    </p>
    <div data-id="element-198">
      <p className="font-bold text-brand-text text-sm" data-id="element-199">— {name}</p>
      <p className="text-xs text-brand-text/70" data-id="element-200">{role}</p>
    </div>
  </div>;
export function TestimonialsSection1() {
  const testimonials = [{
    name: 'María C.',
    role: 'Docente de Bachillerato',
    text: 'Mis alumnos por fin dejan el celular y debaten con ganas.'
  }, {
    name: 'Juan P.',
    role: 'Profesor de Filosofía',
    text: 'Nunca más llegué a clase sin saber cómo explicar un autor difícil.'
  }, {
    name: 'Fernando L.',
    role: 'Docente de Humanidades',
    text: 'Las planificaciones me ahorran horas de tipeo y búsqueda. No improviso nunca más.'
  }];
  return <section className="py-6 md:py-8 px-4 bg-brand-dark" data-id="element-201">
      <div className="max-w-5xl mx-auto" data-id="element-202">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-203">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-204" />)}
        </div>
      </div>
    </section>;
}
export function TestimonialsSection2() {
  const testimonials = [{
    name: 'María C.',
    role: 'Docente de Ética',
    text: 'Lo que más valoro es el Bono de Actividades Anti-IA. Estaba cansada de que todos mis alumnos entregaran tareas hechas con ChatGPT. Con estas dinámicas de reflexión personal y casos reales, por fin puedo evaluar quién piensa de verdad y quién no. Es la mejor inversión que hice este año para mi carrera.'
  }, {
    name: 'Juan P.',
    role: 'Profesor de Ciudadanía',
    text: 'Enseñar Política siempre fue un reto por la falta de materiales neutrales y actualizados. El Tomo 2 sobre el Panóptico Digital y Foucault es una joya. Los chicos se engancharon de inmediato analizando Instagram como una forma de vigilancia. Mis colegas me preguntan qué curso hice para renovar tanto mis clases.'
  }, {
    name: 'Valeria T.',
    role: 'Profesora de Filosofía',
    text: 'El Tomo 1 sobre Lógica y Fake News me salvó. Mis alumnos no querían saber nada con Aristóteles, pero cuando usamos el método socrático para analizar noticias de TikTok, la clase explotó. El material conecta la teoría clásica con su realidad diaria de forma brillante.'
  }, {
    name: 'Carlos R.',
    role: 'Docente de Ética',
    text: 'El Bono del Video-Club Filosófico vale por sí solo el precio del Kit. Antes ponía una película y se dormían. Ahora, con las fichas de trabajo y las preguntas guía, ver Black Mirror o The Truman Show se convierte en un debate ético profundo que dura semanas.'
  }, {
    name: 'Daniel G.',
    role: 'Profesor de Filosofía',
    text: 'La Guía de Dinámicas de Debate transformó mis grupos. Tenía un salón donde nadie hablaba. Apliqué la técnica del Abogado del Diablo y hasta los más tímidos empezaron a argumentar. Es un material hecho por alguien que realmente pisa el aula.'
  }];
  return <section className="py-8 md:py-12 px-4 bg-brand-cardAlt border-y border-black/5" data-id="element-205">
      <div className="max-w-5xl mx-auto" data-id="element-206">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center mb-8 text-brand-text" data-id="element-207">
          💬 TESTIMONIOS de los docentes
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-208">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-209" />)}
        </div>
      </div>
    </section>;
}